// [key, title, description]
// Code framework: NBC/OBC Division B and provincial equivalents

export const CONSTRUCTION_TYPES_CA = [
  [
    'combustible',
    'Combustible Construction',
    'Light wood frame structural system. Most common for Part 9 residential and some Part 3 buildings.',
  ],
  [
    'noncombustible',
    'Noncombustible Construction',
    'Steel, concrete, or masonry structural system. Required for many Part 3 building types.',
  ],
  [
    'heavy_timber',
    'Heavy Timber Construction',
    'Large dimension wood members meeting minimum size thresholds. Governed under Part 3 provisions.',
  ],
  [
    'encapsulated_mass_timber',
    'Encapsulated Mass Timber (EMT)',
    'Tall wood construction using encapsulated CLT, glulam, or NLT members. Governed under Part 3. Increasingly common in mid-rise residential and commercial.',
  ],
];